module.exports = "/5/0-mang-mot-chieu/index.html.2bdadf3c58a38e337057a0de9d3374f6.json"


/*****************
 ** WEBPACK FOOTER
 ** ./content/generated/30080.md
 ** module id = 552
 ** module chunks = 0
 **/